var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V11H9V8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8V10H17V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8Z",
    fill: "#D2D3D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C6.44772 9 6 9.44772 6 10V18C6 18.5523 6.44772 19 7 19H17C17.5523 19 18 18.5523 18 18V10C18 9.44772 17.5523 9 17 9H7ZM13.624 13.624C13.624 14.2638 13.2541 14.8172 12.7164 15.0819L13 16.5H11L11.2836 15.0819C10.7459 14.8172 10.376 14.2638 10.376 13.624C10.376 12.7271 11.1031 12 12 12C12.8969 12 13.624 12.7271 13.624 13.624Z",
    fill: "#D2D3D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.65f1b94fccac94fb918f7c8ce66f1432.svg";
export { ForwardRef as ReactComponent };